import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import "./MainBoxTool.css";

const MainBoxTool = (props: any) => {
  return (
    <>
      <div className="box-fitprenda-tools">
        <Row>
          <Col>
            <p className="font-fitprenda-title">
              {props.title ? props.title : ""}
            </p>
          </Col>
        </Row>
        {props.subtitle ? (
          <Row>
            <Col>
              <p className="font-fitprenda-subtitle">
                <FormattedMessage
                  id={props.subtitle}
                  defaultMessage={props.subtitle}
                />
              </p>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        <Row className="box-fitprenda-tools-internal mx-4">
          {props.children}
        </Row>
        <br />
      </div>
    </>
  );
};

export default MainBoxTool;
